import { render, staticRenderFns } from "./prescriptionOne.vue?vue&type=template&id=1cd6cb6e&scoped=true&"
import script from "./prescriptionOne.vue?vue&type=script&lang=ts&"
export * from "./prescriptionOne.vue?vue&type=script&lang=ts&"
import style0 from "./prescriptionOne.vue?vue&type=style&index=0&id=1cd6cb6e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cd6cb6e",
  null
  
)

export default component.exports